module.exports = __webpack_public_path__ + "assets/ic_character2.cbaa44dd.svg";